// extracted by mini-css-extract-plugin
module.exports = {"info":"style_info__YWB4N","careersInfo":"style_careersInfo__FkNIv","socialbox":"style_socialbox__0sm9N"};